<template>
  <div class="shop-card" :class="{'shop-card--adaptive': isAdaptive, 'shop-card--slider': isSlider, 'shop-card--info-modal': isInfoModal}">
    <div class="shop-card__image-wrap">
      <div class="shop-card__image" :style="{'background-image': 'url(/img/shops/' + encodeURI(shopData.image).replace(/\(/,'\\(').replace(/\)/,'\\)') + ')'}"></div>
    </div>
    <div class="shop-card-info">
      <div class="shop-card-about">
        <div class="shop-card-info__subway-wrap" v-for="(item, idx) in shopData.subway" :key="idx">
          <div v-if="item.color" class="shop-card-info__subway-icon" :style="{'background-color': item.color}"></div>
          <span class="shop-card-info__subway-text">{{ item.name }}</span>
        </div>
        <address class="shop-card-info__address">{{ shopData.description }}</address>
        <span class="shop-card-info__label" :style="{'color': shopData.scheduleObj.label.color}">{{ $t(`${shopData.scheduleObj.label.translationKey}`) }}</span>
        <div v-if="isInfoModal && shopData.scheduleObj.schedule" class="shop-card-info__schedule-wrap">
          <div class="shop-card-info__schedule-item">
            <span class="shop-card-info__schedule-title">{{ $t('shops_shop_schedule_label') }}:</span>
            <span class="shop-card-info__schedule" v-html="shopData.scheduleObj.schedule"></span>
          </div>
          <template v-for="(service, idx) in shopData.storesServices">
            <div class="shop-card-info__schedule-item" :key="idx + Math.random()">
              <span class="shop-card-info__schedule-title">{{ service.name }}:</span>
              <span class="shop-card-info__schedule" v-html="service.scheduleObj.schedule"></span>
            </div>
          </template>
        </div>
        <div v-else-if="shopData.scheduleObj.schedule" class="shop-card-info__schedule-wrap">
          <div
            class="shop-card-info__schedule-item"
            :class="{'shop-card-info__schedule-item--opened': openedSchedules['shop']}"
            @click="toggleSchedulesStatus('shop')"
          >
            <div class="shop-card-info__schedule-text-wrap">
              <span class="shop-card-info__schedule-title">{{ $t('shops_shop_schedule_label') }}:</span>
              <div class="shop-card-info__schedule-text">
                <span class="shop-card-info__text">{{ shopData.scheduleObj.currentSchedule || $t('shops_shop_schedule_not_work') }}</span>
                <span v-if="openedSchedules['shop']" class="shop-card-info__schedule" v-html="shopData.scheduleObj.schedule"></span>
              </div>
            </div>
            <svg width="11"
                 height="12"
                 viewBox="0 0 11 12"
                 fill="none"
                 xmlns="http://www.w3.org/2000/svg">
              <path d="M4.99998 8.57983C4.82076 8.57983 4.64156 8.50781 4.50493 8.36405L0.205142 3.83815C-0.0683806 3.55025 -0.0683806 3.08346 0.205142 2.79567C0.478554 2.50789 0.921935 2.50789 1.19548 2.79567L4.99998 6.80044L8.80451 2.79581C9.07803 2.50803 9.52137 2.50803 9.79476 2.79581C10.0684 3.0836 10.0684 3.55039 9.79476 3.83829L5.49504 8.36419C5.35834 8.50797 5.17914 8.57983 4.99998 8.57983Z" fill="#909090"/>
            </svg>
          </div>
          <template v-for="(service, idx) in shopData.storesServices">
            <div
              class="shop-card-info__schedule-item"
              :class="{'shop-card-info__schedule-item--opened': openedSchedules[transliterate(service.name)]}"
              @click="toggleSchedulesStatus(transliterate(service.name))"
              :key="idx + Math.random()"
            >
              <div class="shop-card-info__schedule-text-wrap">
                <span class="shop-card-info__schedule-title">{{ service.name }}:</span>
                <div class="shop-card-info__schedule-text">
                  <span class="shop-card-info__text">{{ service.scheduleObj.currentSchedule || $t('shops_shop_schedule_not_work') }}</span>
                  <span v-if="openedSchedules[transliterate(service.name)]" class="shop-card-info__schedule" v-html="service.scheduleObj.schedule"></span>
                </div>
              </div>
              <svg width="11"
                   height="12"
                   viewBox="0 0 11 12"
                   fill="none"
                   xmlns="http://www.w3.org/2000/svg">
                <path d="M4.99998 8.57983C4.82076 8.57983 4.64156 8.50781 4.50493 8.36405L0.205142 3.83815C-0.0683806 3.55025 -0.0683806 3.08346 0.205142 2.79567C0.478554 2.50789 0.921935 2.50789 1.19548 2.79567L4.99998 6.80044L8.80451 2.79581C9.07803 2.50803 9.52137 2.50803 9.79476 2.79581C10.0684 3.0836 10.0684 3.55039 9.79476 3.83829L5.49504 8.36419C5.35834 8.50797 5.17914 8.57983 4.99998 8.57983Z" fill="#909090"/>
              </svg>
            </div>
          </template>
        </div>
        <div class="shop-card-info__phone-wrap">
          <span class="shop-card-info__phone-title">{{ $t('shops_shop_phone') }}</span>
          <a :href="'tel:' + shopData.phone" class="shop-card-info__phone-link">{{ shopData.phone }}</a>
        </div>
        <a v-if="isShowRouteBtn"
           :href="decodeURI(routeHref)"
           target="_blank"
           rel="noreferrer"
           class="shop-card__route-btn">
          <svg width="16"
               height="16"
               viewBox="0 0 16 16"
               fill="none"
               xmlns="http://www.w3.org/2000/svg">
            <path d="M15.7622 7.43399L8.56218 0.234C8.25018 -0.0779999 7.74216 -0.0779999 7.43418 0.234L0.234183 7.43399C-0.0778168 7.74599 -0.0778168 8.25401 0.234183 8.56601L7.43418 15.762V15.766C7.74618 16.078 8.25419 16.078 8.56619 15.766L15.7662 8.56601C16.0781 8.24999 16.0781 7.74599 15.7622 7.43399ZM9.59815 9.99798V7.99799H6.39816V10.398H4.79815V7.19801C4.79815 6.75401 5.15414 6.39802 5.59814 6.39802H9.59815V4.398L12.3982 7.19801L9.59815 9.99798Z" fill="#F8F8F8"/>
          </svg>
          {{ $t('site.shops.bulid.route') }}
        </a>
      </div>
      <div class="shop-card-services">
        <button
          v-if="shopData.services.length"
          @click="toggleServicesVisibility"
          class="shop-card-services__toggle-btn"
          :class="{'shop-card-services__toggle-btn--open': showServices}"
        >
          {{ $t('shops_shop_all_services') }}
          <svg width="11"
               height="12"
               viewBox="0 0 11 12"
               fill="none"
               xmlns="http://www.w3.org/2000/svg">
            <path d="M4.99998 8.57983C4.82076 8.57983 4.64156 8.50781 4.50493 8.36405L0.205142 3.83815C-0.0683806 3.55025 -0.0683806 3.08346 0.205142 2.79567C0.478554 2.50789 0.921935 2.50789 1.19548 2.79567L4.99998 6.80044L8.80451 2.79581C9.07803 2.50803 9.52137 2.50803 9.79476 2.79581C10.0684 3.0836 10.0684 3.55039 9.79476 3.83829L5.49504 8.36419C5.35834 8.50797 5.17914 8.57983 4.99998 8.57983Z" fill="#909090"/>
          </svg>
        </button>
        <ul v-if="shopData.services.length" class="shop-card-services__list" :class="{'shop-card-services__list--show': showServices}">
          <li class="shop-card-services__item" v-for="(service, idx) in shopData.services" :key="idx">
            <img :src="service.icon" :alt="service.label" class="shop-card-services__item-icon">
            <span class="shop-card-services__item-label">{{ service.label }}</span>
          </li>
        </ul>
        <a v-if="isShowRouteBtn"
           :href="routeHref"
           target="_blank"
           rel="noreferrer"
           class="shop-card__route-btn">
          <svg width="16"
               height="16"
               viewBox="0 0 16 16"
               fill="none"
               xmlns="http://www.w3.org/2000/svg">
            <path d="M15.7622 7.43399L8.56218 0.234C8.25018 -0.0779999 7.74216 -0.0779999 7.43418 0.234L0.234183 7.43399C-0.0778168 7.74599 -0.0778168 8.25401 0.234183 8.56601L7.43418 15.762V15.766C7.74618 16.078 8.25419 16.078 8.56619 15.766L15.7662 8.56601C16.0781 8.24999 16.0781 7.74599 15.7622 7.43399ZM9.59815 9.99798V7.99799H6.39816V10.398H4.79815V7.19801C4.79815 6.75401 5.15414 6.39802 5.59814 6.39802H9.59815V4.398L12.3982 7.19801L9.59815 9.99798Z" fill="#F8F8F8"/>
          </svg>
          {{ $t('site.shops.bulid.route') }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { transliteration } from '@/mixins/transliteration'

export default {
  name: 'ShopCard',
  mixins: [transliteration],
  props: {
    shopData: {
      type: Object,
      default: () => {}
    },
    isAdaptive: {
      type: Boolean,
      default: false
    },
    isSlider: {
      type: Boolean,
      default: false
    },
    isInfoModal: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      openedSchedules: {
        shop: false
      },
      showServices: false
    }
  },
  computed: {
    ...mapState({
      language: state => state.translation.language
    }),
    isShowRouteBtn () {
      return this.shopData.googleLink || (this.shopData.longitude && this.shopData.latitude)
    },
    routeHref () {
      if (this.isShowRouteBtn) {
        return this.shopData.googleLink || `//maps.google.com/maps?saddr=&daddr=${this.shopData.latitude}, ${this.shopData.longitude}`
      }

      return ''
    }
  },
  methods: {
    toggleSchedulesStatus (name) {
      if (!this.openedSchedules.hasOwnProperty(name)) this.$set(this.openedSchedules, name, true)
      else this.openedSchedules[name] = !this.openedSchedules[name]
    },
    toggleServicesVisibility () {
      this.showServices = !this.showServices
      this.$emit('open', this.showServices)
    }
  }
}
</script>

<style scoped lang="sass">

.shop-card
  position: relative
  display: flex
  flex-direction: column
  width: 100%
  height: 100%
  border: 1px solid #e7e7e7
  border-radius: 3px

  &:not(:last-child)
    margin-bottom: 30px

.shop-card__shop-status
  display: flex
  position: absolute
  left: 0
  top: 20px
  border-radius: 0 3px 3px 0
  padding: 10px

.shop-card__shop-status-label
  color: $white-text-color
  font-size: 12px

.shop-card__content
  padding: 30px 20px

.shop-card__content-item
  width: 100%

  &:not(:last-child)
    margin-bottom: 30px

.shop-card-info
  display: flex
  flex-direction: column
  height: 100%

.shop-card__content-item-image
  width: 100%
  max-height: 220px
  object-fit: cover

.shop-card-about,
.shop-card-services
  display: flex
  flex-direction: column

.shop-card-about
  height: 100%
  padding: 15px 20px 10px

  .shop-card__route-btn
    margin-top: auto

.shop-card-services
  margin-top: auto

  .shop-card__route-btn
    display: none

.shop-card-info__city
  display: none
  font-size: 14px
  color: $placeholder-color
  margin-bottom: 10px

.shop-card-info__address
  display: block
  font-size: 16px
  font-style: normal
  color: $text-color
  margin-bottom: 10px

.shop-card-info__label
  margin-bottom: 15px

.shop-card-info__subway-wrap
  display: flex
  flex-flow: row nowrap
  align-items: center
  margin-bottom: 10px

.shop-card-info__subway-icon
  width: 11px
  height: 11px
  border-radius: 50%

.shop-card-info__subway-text
  font-size: 14px
  color: $text-color
  margin-left: 11px

.shop-card-info__schedule-wrap
  display: flex
  flex-flow: column
  font-size: 14px
  margin-bottom: 15px

.shop-card-info__schedule-item
  display: flex
  flex-flow: row nowrap
  justify-content: space-between
  align-items: flex-start
  border-bottom: 1px solid $nd-border-color
  padding: 10px 5px
  cursor: pointer

  &:first-child
    border-top: 1px solid $nd-border-color

  &--opened
    svg
      transform: rotate(180deg)

  svg
    margin-top: 3px

.shop-card-info__schedule-text-wrap
  display: flex
  flex-flow: row nowrap
  align-items: flex-start
  width: 100%

.shop-card-info__schedule-text
  display: flex
  flex-flow: column
  width: 100%

.shop-card-info__schedule-title
  display: flex
  flex-flow: row nowrap
  margin-right: 10px

  &:before
    display: block
    content: url("/img/svgo/shop-schedule.svg")
    margin-right: 7px
    padding-top: 2px

.shop-card-info__schedule
  color: $placeholder-color
  margin-top: 10px
  white-space: nowrap

.shop-card-info__phone-title
  display: none
  font-size: 14px
  color: $placeholder-color
  margin-bottom: 5px

.shop-card-info__phone-text
  font-size: 16px
  color: $text-color

.shop-card-info__phone-link
  display: flex
  flex-flow: row nowrap
  font-size: 14px
  font-weight: 400
  color: $text-color
  //margin: 10px 0 0
  //padding: 15px 0
  //border-top: 1px solid $nd-border-color

  &:before
    display: block
    content: url("/img/svgo/telephone.svg")
    margin-right: 15px

.shop-card-info__phone-wrap
  margin-bottom: 15px

.shop-card-services__list
  +list-unstyled
  display: none
  padding: 20px

  &--show
    display: block

.shop-card-services__item
  display: flex
  flex-flow: row nowrap

  &:not(:last-child)
    margin-bottom: 10px

.shop-card-services__item-icon
  display: block
  width: 15px
  height: 15px
  object-fit: contain
  filter: grayscale(1)
  margin-right: 15px

.shop-card-services__item-label
  font-size: 14px
  color: $text-color

.shop-card-services__toggle-btn
  display: flex
  flex-flow: row nowrap
  align-items: center
  justify-content: center
  padding: 15px 0
  font-size: 16px
  background-color: transparent
  border: none
  border-top: 1px solid #e7e7e7

  svg
    margin-left: 20px

  &--open
    border-bottom: 1px solid #e7e7e7
    svg
      transform: rotate(180deg)

.shop-card__route-btn
  display: flex
  flex-flow: row nowrap
  justify-content: center
  align-items: center
  border-radius: 3px
  width: 100%
  height: 40px
  color: $white-text-color
  background: $main-color
  margin-top: auto
  font-size: 14px
  font-weight: 500

  svg
    margin-right: 14px

.shop-card__image-wrap
  width: 100%

.shop-card__image
  width: 100%
  padding-top: 56.25%
  background-repeat: no-repeat
  background-position: center
  background-size: cover

.shop-card:not(.shop-card--adaptive)
  +mmin($tablet)
    min-height: 360px
    flex-direction: row

  .shop-card-info__phone-title
    +mmin($tablet)
      display: block

  .shop-card-info__phone-link
    +mmin($tablet)
      font-size: 16px
      border-top: none
      margin: 10px 0 0

    &:before
      +mmin($tablet)
        display: none

  .shop-card__content-item
    +mmin($tablet)
      display: flex

  .shop-card__image-wrap
    +mmin($tablet)
      width: 40%

  //.shop-card__image
  //  +mmin($tablet)
  //    padding-top: 0
  //    background-position: top
  //    background-size: contain

  .shop-card__content-item-image
    +mmin($tablet)
      width: 40%
      max-height: 550px

  .shop-card-info
    +mmin($tablet)
      width: 60%
      height: auto
      padding: 20px

    +mmin($tablet--hor)
      flex-direction: row
      padding: 20px 68px 20px 35px

  .shop-card-about
    +mmin($tablet)
      padding: 0

      .shop-card__route-btn
        display: none

    +mmin($tablet--hor)
      width: 50%
      padding: 0 15px 0 0
      border-right: 1px solid #e7e7e7

  .shop-card-services
    +mmin($tablet)
      margin-top: 0

    +mmin($tablet--hor)
      width: 60%
      padding-left: 30px

    .shop-card__route-btn
      +mmin($tablet)
        display: flex

  .shop-card-info__city
    +mmin($tablet--hor)
      display: block

  .shop-card-info__address
    +mmin($tablet)
      margin-bottom: 15px

    +mmin($tablet--hor)
      font-size: 18px

  .shop-card-info__label
    +mmin($tablet)
      margin-bottom: 25px

  .shop-card-info__subway-wrap
    +mmin($tablet--hor)
      margin-bottom: 20px

  .shop-card-info__schedule-wrap
    +mmin($tablet--hor)
      margin-bottom: 20px

  .shop-card-services__list
    +mmin($tablet)
      display: block
      padding: 0

  .shop-card-services__item
    +mmin($tablet)
      margin-bottom: 10px

  .shop-card-services__toggle-btn
    +mmin($tablet)
      display: none

.shop-card--slider
  position: relative

  .shop-card-services__list
    background-color: #fff
    position: absolute
    top: 100%
    left: -1px
    right: -1px
    border: 1px solid #e7e7e7

  .shop-card-services__toggle-btn
    border-bottom: none

.shop-card--info-modal
  .shop-card-info__schedule-wrap
    flex-flow: row nowrap

  .shop-card-info__schedule-item
    flex-flow: column
    border: none
    padding: 0
    justify-content: flex-start

    &:first-child
      margin-right: 20px

  .shop-card-info__schedule-title
    color: $placeholder-color

    &:before
      display: none

  .shop-card-info__schedule
    color: $text-color
    margin-top: 5px

  .shop-card-info__subway-wrap
    display: none

  .shop-card-info__phone-wrap
    margin: 0

  .shop-card-info__phone-link
    padding: 15px 0
    border-top: 1px solid $nd-border-color
    border-bottom: 1px solid $nd-border-color

  .shop-card-services__toggle-btn
    display: none

  .shop-card-services__list
    display: block
    padding: 20px 20px 60px

  .shop-card__route-btn
    position: fixed
    bottom: 0
    left: 0
    right: 0
    z-index: 1

</style>
